import { unreadonly } from '../../../types/unreadonly';
import type { TableFilterBase } from '../TableFilter';
import { filterOperators } from '../operators';

const booleanFilterOperators = unreadonly([
  ...filterOperators.boolean,
  ...filterOperators.empty,
  ...filterOperators.column,
  ...filterOperators.color,
] as const);

export type BooleanFilterOperator = (typeof booleanFilterOperators)[number];

export type BooleanSelectFilterOption = {
  label: string;
  value: 'true' | 'false' | 'null';
};
export type BooleanTableFilter = TableFilterBase & {
  type: 'boolean';
  options: BooleanSelectFilterOption[];
};

export const createBooleanFilter = (
  options?: BooleanSelectFilterOption[],
): BooleanTableFilter => ({
  type: 'boolean',
  operators: booleanFilterOperators,
  options: options ?? [
    {
      label: 'Yes',
      value: 'true',
    },
    {
      label: 'No',
      value: 'false',
    },
    {
      label: 'Empty',
      value: 'null',
    },
  ],
});
